import script from "./GoogleLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleLoginButton.vue?vue&type=style&index=0&id=6746ee68&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6746ee68"]])

export default __exports__